import React, { useState } from 'react';
import Table from '../common/Table';
import tableConfig, { data } from './config';
import { withRouter } from 'react-router-dom';
import { GET_FOOD_ITEMS } from '../../constants';
import { toast } from 'react-toastify';
import { deleteitem } from '../../actions/fooditems';
import Button from '../common/Button';
import Grid from '@material-ui/core/Grid';

const FoodItems = (props) => {
  const classes = props.classes;
  let config = tableConfig(props);
  let session = sessionStorage.getItem('user');
  const [countryid, setCountryid] = useState(session ? `${JSON.parse(session).countryId}` : "");
  const [isLoading, setLoading] = useState(false);
  const [tableKey, setTableKey] = useState(1);
  const [delitem, setDelitem] = useState({
    itemId: "",
  })
  //console.log("countryid",countryid);
  const onView = (rowdata) => { props.history.push(`/fooditems/${rowdata.itemId}`) }
  const onEdit = (rowdata) => {
    console.log("itemdetails", rowdata);
    props.history.push(`/updateitem/${rowdata.sellerId}/${rowdata.itemId}/${rowdata.cityId}`)
  }
  const onDelete = (rowdata) => {
    setLoading(true);
    setDelitem({
      itemId: rowdata.itemId,
    });

    deleteitem(rowdata.itemId, (message, isError) => {
      const method = isError ? 'error' : 'success';
      toast[method](message);
      setLoading(false);
      if (method === "success") {
        setTableKey(tableKey + 1);
      }
    })
  }

  return (
    <div>
      <div>
        <Grid container spacing={2}>
          <Grid item xs={10}></Grid>
          <Grid item xs={2}>
            <Button label={'Add Food Item'} color="primary" onClick={() => { props.history.push(`/additems`) }} />
          </Grid>
        </Grid>
      </div>
      <br></br>
      <Table
        key={tableKey}
        tableConfig={config}
        data={data}
        onView={onView}
        onEdit={onEdit}
        onDelete={onDelete}
        apidata="items"
        countryid={countryid}
        url={GET_FOOD_ITEMS}
      />
    </div>
  )
};

export default withRouter(FoodItems);
